<h3 *ngIf="title">
  {{ title }}
</h3>

<nz-row [nzGutter]="[5, 5]">
  <nz-col
    *ngFor="let mediaItem of displayedMedia; index as i; trackBy: trackBySource"
    [style.display]="i < visibleThumbsCount ? 'block' : 'none'"
    [nzXXl]="3"
    [nzXl]="4"
    [nzLg]="6"
    [nzMd]="3"
    [nzSm]="4"
    [nzXs]="6"
  >
    <app-lot-carousel-thumbs-item
      [mediaItem]="mediaItem"
      [index]="mediaItem.index"
      (thumbSelected)="activeSlideIndexChanged.emit($event)"
    ></app-lot-carousel-thumbs-item>
  </nz-col>

  <nz-col
    *ngIf="hasExtraThumb"
    [nzXXl]="3"
    [nzXl]="4"
    [nzLg]="6"
    [nzMd]="3"
    [nzSm]="4"
    [nzXs]="6"
  >
    <ng-content select="app-lot-watch-request-buy-button"></ng-content>
  </nz-col>
</nz-row>

<ng-content select="app-lot-carousel-thumbs-actions"></ng-content>
